export default "__VITE_ASSET__BvhHvS7S__"